<div class="row justify-content-center">
    <div class="section over-hide full-height full-height-xl">
        <div #swiperContainer class="section swiper-hero-corporate-v1">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-1 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                United <br><span class="display-3 typed-1 color-primary"></span>

                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Bringing Rajputs together across North America to build a stronger community.
                            </p>

                            <div routerLink="/login" class="btn btn-danger  fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form"
                                 class="btn btn-warning btn-border-danger fade-hero mx-2 z-bigger ">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>

                            <p class="mb-0 mt-2 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>

                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-2 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                Preserving Heritage and <br><span class="display-3 typed-1 color-primary">Legacy.</span>
                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Safeguarding Rajputana traditions while honoring our rich legacy for generations.
                            </p>
                            <div routerLink="/login" class="btn btn-danger fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form" class="btn btn-warning fade-hero mx-2 z-bigger">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>
                            <p class="mb-0 mt-2 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-6 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                Empowerment and <br><span class="display-3 typed-1 color-primary">a Support.</span>
                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Empowering Rajputs to thrive through collaboration, growth, and uplifting guidance.
                            </p>
                            <div routerLink="/login" class="btn btn-danger fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form" class="btn btn-warning fade-hero mx-2 z-bigger">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>
                            <p class="mb-0 mt-2 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-4 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                Celebrating Culture and <br><span class="display-3 typed-1 color-primary">Pride.</span>
                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Showcasing Rajputana's glory while embracing our history with pride.
                            </p>
                            <div routerLink="/login" class="btn btn-danger fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form" class="btn btn-warning fade-hero mx-2 z-bigger">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>
                            <p class="mb-0 mt-2 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-5 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                Inspiring <br><span class="display-3 typed-1 color-primary">Leadership <span
                                    class="display-3 typed-1 color-light-2"> & </span>  Strength.</span>
                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Fostering resilient communities and inspiring vision within the Rajput diaspora.
                            </p>
                            <div routerLink="/login" class="btn btn-danger fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form" class="btn btn-warning fade-hero mx-2 z-bigger">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>
                            <p class="mb-0 mt-2 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="section full-height full-height-xl over-hide corporate-hero-back-img-3 parallax-hero-1200">
                        <div class="hero-center-section text-center px-2">
                            <h2 class="display-1 mb-3 color-light-2  text-center fade-hero" data-swiper-parallax-y="200"
                                data-swiper-parallax-duration="600">
                                Engaging Rajput Youth in the <br><span
                                    class="display-3 typed-1 color-primary">Diaspora.</span>
                            </h2>
                            <p class="lead font-weight-300 display-4 mb-5  text-center fade-hero"
                               data-swiper-parallax-y="150" data-swiper-parallax-duration="500">
                                Connecting Rajput youth in America and the UK to their rich culture and heritage.
                            </p>
                            <div routerLink="/login" class="btn btn-danger fade-hero mx-2 z-bigger">Sign In<i
                                    class="uil uil-entry size-22"></i></div>
                            <div routerLink="/register-form" class="btn btn-warning fade-hero mx-2 z-bigger">Become a new member<i
                                    class="uil uil-exit size-22"></i></div>
                            <p class="mb-0 text-sm-center size-16 text-white">
                                Couldn't find your email?
                                <a routerLink="/contact-us"
                                   class="link link-normal animsition-link text-rana-secondary">Contact Us</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section over-hide">
        <div class="section-1400">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <div class="section divider"></div>
                    </div>
                </div>
            </div>
            <div
                    class="container-fluid padding-top-bottom-80"
                    data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s"
            >
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-3 text-center border-counters-right">
                        <div class="counter-big-num mb-0 font-weight-400">

                            <div class="counter-container">
                                <div class="counter" [appCounterUp]="1500">+
                                    0
                                </div>

                            </div>

                        </div>
                        <p
                                class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                        >
                            Rajput Families
                        </p>
                    </div>
                    <div
                            class="col-md-6 col-lg-3 mt-5 mt-md-0 text-center border-counters-right"
                    >
                        <div class="counter-big-num mb-0 font-weight-400">
                            <div class="counter" [appCounterUp]="500">+
                                0
                            </div>
                        </div>
                        <p
                                class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                        >
                            Rajput Youths
                        </p>
                    </div>
                    <div
                            class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center border-counters-right"
                    >
                        <div class="counter-big-num mb-0 font-weight-400">
                            <span class="counter" [appCounterUp]="5">0</span>K+
                        </div>
                        <p
                                class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                        >
                            Events
                        </p>
                    </div>
                    <div class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center">
                        <div class="counter-big-num mb-0 font-weight-400">
                            <span class="counter" [appCounterUp]="15">0</span>
                        </div>
                        <p
                                class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue"
                        >
                            Chapters
                        </p>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-6 col-md-4 col-lg-3 text-center">
                        <div class="section divider"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

